import api from "api/api";
import { consumerFilterPayload } from "utils/consumerFilterUtils";

const TEXT_THEME_API_PATH = `${process.env.REACT_APP_SERVER_PATH}/themes/generate-themes/`;
const themeRequestCache = new Map();

const getThemeRequestKey = (payload) => JSON.stringify(payload);

const postThemeRequest = (payload) => {
    const requestKey = getThemeRequestKey(payload);

    if (!themeRequestCache.has(requestKey)) {
        const request = api.post(TEXT_THEME_API_PATH, payload).finally(() => {
            window.setTimeout(() => themeRequestCache.delete(requestKey), 5000);
        });

        themeRequestCache.set(requestKey, request);
    }

    return themeRequestCache.get(requestKey);
};

const GenerateTextThemes = async ({ selections, productCategory, consumerFilter, localConsumerFilters = {}, selectionKeys: requestedSelectionKeys = null, backendVariableMacroCategory = {} }) => {
    const safeConsumerFilter = consumerFilter || {};
    const selectionKeys = requestedSelectionKeys || selections
        .filter(item => item.isSelected)
        .map(item => `${item.coreDataId}-${item.productCodeTitle}-${item.backendVariable}`);
    if (selectionKeys.length === 0) {
        return [];
    }

    const groupedSelections = Object.values(selectionKeys.reduce((groups, key) => {
        const keyParts = key.split("-");
        const coreDataId = keyParts.shift() || "";
        const backendVariables = (keyParts.pop() || "").split(",").filter(Boolean);
        const productCodeRaw = keyParts.join("-");
        const relatedBackendVariable = backendVariableMacroCategory[backendVariables[0]];
        const groupKey = [coreDataId, productCodeRaw, relatedBackendVariable].join("|");

        if (!groups[groupKey]) {
            groups[groupKey] = {
                coreDataId,
                productCodeRaw,
                backendVariables: [],
            };
        }
        groups[groupKey].backendVariables.push(...backendVariables);
        return groups;
    }, {})).map((group) => ({
        ...group,
        selectionKey: `${group.coreDataId}-${group.productCodeRaw}-${group.backendVariables.join(",")}`,
    }));

    const payloads = await Promise.all(
        groupedSelections.map(async (group) => {
            const core_data_id = group.coreDataId;
            const backend_variable = group.backendVariables.join(",");
            const product_code_raw = group.productCodeRaw;
            const product_code = product_code_raw.replace(/_/g, " ");
            const filter = localConsumerFilters[group.selectionKey] || await consumerFilterPayload(safeConsumerFilter, product_code_raw, core_data_id);

            return {
                core_data_id: parseInt(core_data_id, 10),
                product_category: productCategory?.value,
                backend_variable,
                product_code,
                data_type: "Open Ended",
                consumer_filter: filter,
            };
        })
    );

    const requests = payloads.map((payload) => postThemeRequest(payload));
    const responses = await api.all(requests);

    return responses.map((res, index) => ({
        ...res.data,
        selectionKey: groupedSelections[index].selectionKey,
    }));
};

export default GenerateTextThemes;
